import { render, staticRenderFns } from "./HTMLTextarea.vue?vue&type=template&id=99b4a006&"
import script from "./HTMLTextarea.vue?vue&type=script&lang=js&"
export * from "./HTMLTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports